// extracted by mini-css-extract-plugin
export default {"bgWhiteWarm":"bgWhiteWarm___TuE21","colorGreenSlate":"colorGreenSlate___mOdmp","letterSpacingNormal":"letterSpacingNormal___lx83S"};